
/*
    Display for a single Lane Change record,
    split into media queries for different screen sizes

    can be expanded to display a form to edit that data
*/

import React from "react";

import Media from "react-media";

import DataItem from "../Components/DataItem";

import LaneChangeForm from "../Forms/LaneChangeForm";
import { deleteLaneChange } from "../Requests/LaneRequests";

/*
    from_date: "19-SEP-20"
    from_time: "0930"
    new_value: "314"
    original_value: "315"
    terminal: "PABT"
    to_date: "19-DEC-20"
    to_time: "1030"
    type: "Gate Change"
*/

/*
{
    location_id: "PABT",
    route: 134,
    current_gate: 111,
    new_gate: 112,
    start_date: "DD-MON-YY HH:MI AM",
    end_date: "DD-MON-YY HH:MI AM",
    last_modified: "DD-MON-YY HH:MI AM",
    username: "VISSRXN"
}
*/

const formatData = (data) => {
    const copy = {...data};

    console.log("THE DATA", copy);

    const startSplit = copy.start_date.split(" ");
    const endSplit = copy.end_date.split(" ");
    copy.start_date = startSplit[0];
    copy.start_time = removeSeconds(startSplit[1]);
    copy.start_time_suffix = startSplit[2];
    copy.end_date = endSplit[0];
    copy.end_time = removeSeconds(endSplit[1]);
    copy.end_time_suffix = endSplit[2];

    return copy;
}

const removeSeconds = (time) => {
    const split = time.split(":");
    return split[0] + ":" + split[1];
}

export default class LaneChangeData extends React.Component {
    render() {

        const data = formatData(this.props.data);

        const deleteChange = (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            console.log("DELETE CHANGE", data.id);
            deleteLaneChange({id: data.id})
            .then(res => {
                this.props.deleteHandler();
            });
        }

        return (
            <>
            {
                this.props.expanded 
                ? <div className="data data-expanded vertical" style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"            
                }}>
                    <LaneChangeForm data={data} location={this.props.location} isEdit={true} onSubmit={this.props.onSubmit} index={this.props.containerIndex} close={() => this.props.runOpen(null)} />
                    <div className="option option-low-vertical"
                        style={{
                            alignSelf:"flex-end",
                            justifySelf:"flex-end",
                            margin: "6px",
                            marginRight: "12px"
                        }}
                        onClick={() => this.props.runOpen(null)}
                    >
                        Close
                    </div>
                </div>
                : <div style={{display: "flex", flexDirection: "column"}}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        backgroundColor: "#ee4444",
                        margin: "0 1px",
                        padding: "0.1rem 0.25rem",
                        color: "white",
                        fontSize: "0.8rem"
                    }}>
                        <div>
                            {data.location_id}
                        </div>
                        <div style={{fontSize: "0.7rem"}}>
                            ({data.username} {data.last_modified})
                        </div>
                    </div>
                    <Media query="(max-width: 811px)">
                        <div className="data" style={{
                            display: "grid",
                            gridGap: "4px",
                            gridTemplateColumns: "1fr 1fr 1fr",
                            padding: "8px 0 8px 32px",
                            alignItems: "center"
                        }}
                        onClick={() => this.props.runOpen(this.props.containerIndex)}
                        >
                            <div>Orig Lane: <DataItem val={(data.current_gate != -1) ? data.current_gate : ""} /></div>
                            <div>Start: <DataItem val={data.start_date} /> <DataItem val={data.start_time} />&nbsp;<DataItem val={data.start_time_suffix} /></div>
                            <div>Route: <DataItem val={(data.route != -1) ? data.route : ""} /></div>
                            <div>New Lane: <DataItem val={data.new_gate} /></div>
                            <div>End: <DataItem val={data.end_date} /> <DataItem val={data.end_time} />&nbsp;<DataItem val={data.end_time_suffix} /></div>
                            <div className="option" onClick={(evt) => deleteChange(evt)} >Delete</div>
                        </div>
                    </Media>
                    <Media query="(min-width: 812px)">
                        <div className="data" style={{
                            display: "grid",
                            gridTemplateColumns: "2fr 2fr 2fr 3fr 3fr 1fr",
                            padding: "8px 16px",
                            alignItems: "center"
                        }}
                        onClick={() => this.props.runOpen(this.props.containerIndex)}
                        >
                            <div>Route: <DataItem val={(data.route != -1) ? data.route : ""} /></div>
                            <div>Orig Lane: <DataItem val={(data.current_gate != -1) ? data.current_gate : ""} /></div>
                            <div>New Lane: <DataItem val={data.new_gate} /></div>
                            <div>Start: <DataItem val={data.start_date} /> <DataItem val={data.start_time} />&nbsp;<DataItem val={data.start_time_suffix} /></div>
                            <div>End: <DataItem val={data.end_date} /> <DataItem val={data.end_time} />&nbsp;<DataItem val={data.end_time_suffix} /></div>
                            <div className="option" style={{padding: "6px"}} onClick={(evt) => deleteChange(evt)} >Delete</div>
                        </div>
                    </Media>
                </div>    
            }
            </>
        );
    }
}